<template lang="pug">
input.form-control(
  v-bind="$attrs"
  :name="name"
  :type="type"
  :class="inputClasses"
  :value="modelCompatValue"
  :placeholder="placeholder"
  :required="required"
  :disabled="disabled"
  :readonly="readonly"
  :data-test-id="dataTestId || null"
  @click="onClick"
  @focus="onFocus"
  @blur="onBlur"
  @input="onInput"
  @keyup.up="onUp"
  @keyup.down="onDown"
  @keypress.enter="onEnter"
  @change="onChange"
  )
</template>

<script>
export default {
  name: 'AppInput',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
    },
    dataTestId: {
      type: String,
    },
    modelValue: {
      type: [String, Number],
      default: undefined,
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    type: {
      type: String,
      default: 'default',
    },
    required: {
      type: Boolean,
      default: false,
    },
    debounce: {
      default: 600,
    },
  },
  emits: ['input', 'update:modelValue', 'up', 'down', 'enter', 'change', 'focus', 'blur', 'click'],
  data: () => ({
    timeoutId: null,
  }),
  computed: {
    modelCompatValue() {
      return this.value !== undefined ? this.value : this.modelValue;
    },
    inputClasses() {
      const classes = [];

      // Type classes
      switch (this.type) {
        case 'search':
          classes.push('search');
          break;
        default:
          classes.push(`input-${this.type}`);
      }

      return classes;
    },
  },
  methods: {
    onInput(event) {
      const value = event.target.value;

      if (this.type === 'search' && this.debounce) {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }

        if (value.length) {
          this.timeoutId = setTimeout(() => {
            // Emit `update:modelValue` BEFORE `input` so v-model updates before any `@input`
            // handler runs (Vue 2 parity) — otherwise an `@input` consumer reads the stale value.
            this.$emit('update:modelValue', value);
            this.$emit('input', value);
          }, this.debounce);

          return;
        }
      }

      this.$emit('update:modelValue', value);
      this.$emit('input', value);
    },
    onUp(event) {
      this.$emit('up', event);
    },
    onDown(event) {
      this.$emit('down', event);
    },
    onEnter(event) {
      if (this.type === 'search' && this.debounce) {
        this.$emit('update:modelValue', event.target.value);
        this.$emit('input', event.target.value, true);
      } else {
        this.$emit('enter', event);
      }
    },
    focus() {
      this.$el.focus();
    },
    onChange(event) {
      const value = event.target.value;

      this.$emit('change', value);
    },
    onFocus(event) {
      this.$emit('focus', event);
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>
